import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import {
    useOrderAvailableTimes,
    useOrderExpectedAt,
    useOrderIsSyncingTimeSlots,
    setOrderExpectedAt,
} from '@/hooks/api/order';

const OrderTimePicker = () => {
    const [t] = useTranslation('order.datetime');

    const is_syncing = useOrderIsSyncingTimeSlots();
    const expected_at = useOrderExpectedAt();
    const available_times = useOrderAvailableTimes();

    let expected_at_index_in_available_times =
        available_times &&
        available_times.findIndex(
            time => time.datetime_value === expected_at?.datetime_value
        );

    if (expected_at_index_in_available_times === -1) {
        expected_at_index_in_available_times = 0;
    }

    const onChange = useCallback(
        event => {
            const index = event.target.value;
            setOrderExpectedAt(available_times[index]);
        },
        [available_times]
    );

    return (
        <div
            className="m2g-order-time m2g-input-container"
            data-icon-after={
                !is_syncing && available_times.length ? 'select' : null
            }
            data-view="order-times"
            data-is-loading={is_syncing}
        >
            {available_times?.length ? (
                <select
                    data-order-times
                    className="m2g-order-time-select m2g-select"
                    value={expected_at_index_in_available_times}
                    onChange={onChange}
                >
                    {available_times.map((time, index) => (
                        <option
                            key={time.datetime_value + time.display_value}
                            value={index}
                        >
                            {time.display_value}
                        </option>
                    ))}
                </select>
            ) : (
                <select
                    data-order-times
                    className="m2g-order-time-select m2g-select m2g-text--offset"
                >
                    <option value="">{is_syncing ? '' : t('closed')}</option>
                </select>
            )}
        </div>
    );
};

export default OrderTimePicker;
